export default [
  {
    name: "UNISAGRADO - Bauru, SP",
    image: "usc.png",
    description: "Ensino Superior – Bacharelado de Ciências da Computação",
    start: "Wed, 01 Jan 2015 03:00:00 GMT",
    end: "Wed, 01 Dec 2019 03:00:00 GMT"
  },
  {
    name:
      "Colégio Técnico Industrial Professor Isaac Portal Roldán - Bauru, SP",
    image: "cti.png",
    description: "Ensino médio e Ensino Técnico de Informática",
    start: "Wed, 01 Jan 2013 03:00:00 GMT",
    end: "Wed, 01 Jan 2015 03:00:00 GMT"
  }
];
